import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { subDays } from "date-fns";

interface MachineUsageState {
  isEnabled: boolean;

  preferences: {
    defaultTimeView: "hourly" | "daily" | "monthly";
    trackedMachineTypes: string[];
    defaultDateRange: number; // days
  };

  filters: {
    timeView: "hourly" | "daily" | "monthly";
    selectedMachineTypes: string[];
    dateRange: {
      start: string; // ISO string
      end: string;
    };
  };

  setupWizard: {
    currentStep: number;
    selectedMachineTypes: string[];
  };
}

const initialState: MachineUsageState = {
  isEnabled: false,
  preferences: {
    defaultTimeView: "daily",
    trackedMachineTypes: [],
    defaultDateRange: 30,
  },
  filters: {
    timeView: "daily",
    selectedMachineTypes: [],
    dateRange: {
      start: subDays(new Date(), 30).toISOString(),
      end: new Date().toISOString(),
    },
  },
  setupWizard: {
    currentStep: 0,
    selectedMachineTypes: [],
  },
};

const machineUsageSlice = createSlice({
  name: "machineUsage",
  initialState,
  reducers: {
    enableModule: (state) => {
      state.isEnabled = true;
    },
    disableModule: (state) => {
      state.isEnabled = false;
    },
    updatePreferences: (
      state,
      action: PayloadAction<Partial<MachineUsageState["preferences"]>>,
    ) => {
      state.preferences = { ...state.preferences, ...action.payload };
    },
    updateFilters: (
      state,
      action: PayloadAction<Partial<MachineUsageState["filters"]>>,
    ) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    updateSetupWizard: (
      state,
      action: PayloadAction<Partial<MachineUsageState["setupWizard"]>>,
    ) => {
      state.setupWizard = { ...state.setupWizard, ...action.payload };
    },
    resetSetupWizard: (state) => {
      state.setupWizard = initialState.setupWizard;
    },
  },
});

export const {
  enableModule,
  disableModule,
  updatePreferences,
  updateFilters,
  updateSetupWizard,
  resetSetupWizard,
} = machineUsageSlice.actions;

export default machineUsageSlice.reducer;
